// Allow Hot Module Replacement (HMR) for JS files
// For more details see https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept();
}

const removeStageContentVideoControlsImmediately = () => {
  document.querySelectorAll('.stage-content__background video').forEach((video) => {
    video.removeAttribute('controls');
  });
};

const initStageContentVideoControls = () => {
  document.querySelectorAll('.stage-content__background').forEach((background) => {
    const video = background.querySelector('video');
    const btn = background.closest('.stage-content')?.querySelector('.stage-content__video-control');
    const stage = background.closest('.stage-content');

    if (!video || !btn || !stage) return;

    video.removeAttribute('controls');

    const updateState = (playing) => {
      btn.setAttribute('aria-pressed', playing ? 'true' : 'false');
      btn.setAttribute('aria-label', playing ? 'Stop' : 'Play');
    };

    updateState(!video.paused);

    const setStoppedByUser = (stopped) => {
      stage.classList.toggle('video-stopped-by-user', stopped);
    };

    video.addEventListener('play', () => updateState(true));
    video.addEventListener('pause', () => updateState(false));

    btn.addEventListener('click', () => {
      if (video.paused) {
        setStoppedByUser(false);
        video.play();
      } else {
        setStoppedByUser(true);
        video.pause();
      }
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !stage.classList.contains('video-stopped-by-user')) {
            video.play();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(background);
  });
};

const initStage = () => {
  initStageContentVideoControls();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStage, { once: true });
} else {
  initStage();
}

removeStageContentVideoControlsImmediately();

import './stage-content.scss';
